import React, { useState } from "react";
import Carousel from "react-material-ui-carousel";
import { Paper, Button, Typography } from "@mui/material";

const SecondExample = () => {
  return (
    <div style={{ color: "#494949", width: "100%" }}>
      <Carousel className="SecondExample">
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Carousel>
    </div>
  );
};

function Project({ item }) {
  return (
    <Paper className="Project">
      <img src={item.img} alt="" />
    </Paper>
  );
}

const items = [
  {
    img: "/assets/login/c1.svg",
  },
  {
    img: "/assets/login/c2.svg",
  },
  {
    img: "/assets/login/c3.svg",
  },
  {
    img: "/assets/login/c4.svg",
  },
];

export default SecondExample;
